import React, {useEffect, useState} from 'react'
import {createPortal} from 'react-dom'

import {Modal} from 'react-bootstrap'
import {checkUploadStatus, alert, toaster} from '../../../../../utils/helper'
import {useMutation} from '@apollo/client'
import closeIcon from '../../../../../_metronic/images/closeSymbol.svg'

import {useFormik} from 'formik'
import {UPLOAD_AGENTS, CREATE_AGENTS} from '../../../../../utils/GraphQLAPI'

import AddAgent from '../steps/AddAgent'

import * as Yup from 'yup'
import uuid from 'react-uuid'
type Props = {
  show: boolean
  handleClose: () => void
  refetchList: () => void
  salesChannelId?: string
  agentLeaderList: any
  handleCreateAgentSubmit: any
}

const modalsRoot = document.getElementById('root-modals') || document.body

const CreateAgentModel = ({
  show,
  handleClose,
  refetchList,
  salesChannelId,
  agentLeaderList,
  handleCreateAgentSubmit,
}: Props) => {
  const initialFormValue = {
    agent: [
      {
        agentFirstName: '',
        agentLastName: '',
        agentEmailID: '',
        agentLeaderCode: null,
      },
    ], //agentList
    agentLeaders: agentLeaderList,
  }
  const [generatedTrackId, setGenerateTrackId] = useState<any>('')
  useEffect(() => {
    setGenerateTrackId(uuid())
  }, [])

  const [uploadAgent] = useMutation(UPLOAD_AGENTS, {
    onCompleted: (data) => {
      //Checking the status
      checkUploadStatus(generatedTrackId, refetchList)
      handleClose()
      refetchList()
      formik.setValues(initialFormValue)
    },
    onError: (error) => alert(error.message, 'error'),
  })
  const validationSchema = Yup.object().shape({
    agent: Yup.array().of(
      Yup.object().shape({
        agentFirstName: Yup.string().required('First Name is required'),
        agentLastName: Yup.string().required('Last Name is required'),
        agentEmailID: Yup.string().required('Email ID is required'), // these constraints take precedence
      })
    ),
  })
  const formik = useFormik({
    initialValues: initialFormValue,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const agentValue: any = formik.getFieldMeta('agent').value
      handleCreateAgentSubmit(
        agentValue,
        createAgents,
        uploadAgent,
        generatedTrackId,
        salesChannelId
      )
      // refetchList()
    },
  })

  // Sync Call
  const [createAgents] = useMutation(CREATE_AGENTS, {
    onCompleted: async (data) => {
      if (data.createAgents) {
        toaster(data.createAgents, 'success')
      }
      handleClose()
      refetchList()
      formik.setValues(initialFormValue)
    },
    onError: (error) => console.log(error.message),
  })
  const handleHide = () => {
    formik.setValues(initialFormValue)
    handleClose()
  }
  useEffect(() => {
    formik.setFieldValue('agentLeaders', agentLeaderList)
  }, [agentLeaderList])

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName={' modal-dialog-scrollable mw-650px'}
      show={show}
      onHide={handleHide}
      backdrop={true}
    >
      <div className='modal-header'>
        <h4 className='modal-title '>Add Agent</h4>
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleHide}>
          <img className='svg-icon-1' src={closeIcon} alt='close' />
        </div>
      </div>

      <div className='modal-body'>
        <AddAgent formik={formik} />
      </div>
      <div className='modal-footer'>
        <button
          type='button'
          className='btn btn-light'
          data-bs-dismiss='modal'
          onClick={handleHide}
        >
          Discard
        </button>
        <button type='submit' className='btn btn-primary' onClick={() => formik.submitForm()}>
          Submit
        </button>
      </div>
    </Modal>,
    modalsRoot
  )
}

export {CreateAgentModel}
